import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import NavItems from './NavItems';
import NavToggle from './NavToggle';

import e84logo from '../assets/images/logo_white.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import faTimes from '@fortawesome/fontawesome-free-solid/faTimes';

import { e84_default_routes } from '../lib/routes';

const Nav = ({
  isOpen,
  closeNav,
  toggleNav,
  showPanelLogo = true,
  routes = e84_default_routes,
}) => {

  return (
    <nav className="e84-site-nav" data-is-open={ isOpen }>
      <div className="e84-site-nav-options">
        { showPanelLogo && (
          <Link to="/" className="e84-site-nav-logo">
            <img src={ e84logo } alt="E84 Logo - Click to go home" />
          </Link>
        ) }

        <NavToggle isOpen={ isOpen }
          modifierClass="nav-toggle-inner"
          onClick={ toggleNav }
        >
          <FontAwesomeIcon icon={ faTimes } />
        </NavToggle>
      </div>

      <NavItems modifier="site" onClick={ closeNav } routes={ routes } />
    </nav>
  );

};

Nav.propTypes = {
  isOpen: PropTypes.bool,
  closeNav: PropTypes.func,
  toggleNav: PropTypes.func,
  showPanelLogo: PropTypes.bool,
  routes: PropTypes.array,
};

export default Nav;
